<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable.vue";

export default {
  name: 'QianchuanViolationWord',
  components: {CommonTable},
  data() {
    return {
      searchs: [],
      permission: {
        add: 'qianchuanViolationWord:add',
        update: 'qianchuanViolationWord:update',
        delete: 'qianchuanViolationWord:delete',
        deleteBatch: 'qianchuanViolationWord:deleteBatch'
      },
      url: {
        get: '/qianchuanViolationWord/listByCondition',
        add: '/qianchuanViolationWord/add',
        update: '/qianchuanViolationWord/update',
        delete: '/qianchuanViolationWord/delete',
        delete_batch: '/qianchuanViolationWord/deleteBatch',
        status: '/qianchuanViolationWord/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      },
        {
							field: 'violationWord',  // 字段名
							label: '违规词',  // 字段显示名称
							sort: false,  // 是否排序
							show: true,  // 是否展示
						},
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [

          {
							field: 'violationWord',  // 字段名
							label: '违规词',  // 字段显示名称
							type: 'input',
							placeholder: '请输入违规词',
							rules: [
									{ required: true, message: '违规词不能为空', trigger: 'blur'}
								],
							add: true,
							update: true,
						},
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped>

</style>
